import axios from 'axios';

export default {
    getAll() {
        return axios.get(window.API_BASE + '/settings/locations');
    },

    store(params) {
        return axios.post(window.API_BASE + '/settings/locations', params);
    },

    update(id, params) {
        return axios.put(window.API_BASE + '/settings/locations/' + id, params);
    },

    delete(id) {
        return axios.delete(window.API_BASE + '/settings/locations/' + id);
    }
}